export default function isExternalLink(link) {
  function checkDomain(link) {
    if (link.indexOf("//") === 0) {
      link = location.protocol + link;
    }
    return link
      .toLowerCase()
      .replace(/([a-z])?:\/\//, "$1")
      .split("/")[0];
  }

  return (
    (link.indexOf(":") > -1 || link.indexOf("//") > -1) &&
    checkDomain(location.href) !== checkDomain(link)
  );
}
